import axios from 'axios';
import { getApiUrl } from '../../../../util/util';

const apiClient = axios.create({});
apiClient.interceptors.request.use(async (config) => {
	config.baseURL = getApiUrl();
	return config;
});

export default apiClient;
